import React from 'react';
import PropTypes from 'prop-types';
import {Dropdown} from 'primereact/dropdown';
import {isArray, map} from 'lodash';

export const TypeOfProducts = [
    {label: 'All', value: 'ALL'},
    {label: 'Free', value: 'FREE'},
    {label: 'Rental', value: 'RENTAL'},
    {label: 'Not Subscribed', value: 'NOT_SUBSCRIBED'},
    {label: 'EST', value: 'EST'},
];

const productTypeList = ({onChange, value, id}) => (
    <Dropdown
        filter={false}
        filterBy="label,value"
        filterPlaceholder="Select Product"
        id={id}
        options={
            isArray(TypeOfProducts)
                ? map(TypeOfProducts, product => ({
                      label: product.label,
                      value: product.value,
                  }))
                : []
        }
        showClear={false}
        style={{width: '300px'}}
        value={value}
        onChange={onChange}
    />
);

productTypeList.propTypes = {
    id: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    value: PropTypes.string.isRequired,
};

export default productTypeList;
